export const ru = {
    'save': 'Сохранить',
    'cancel': 'Закрыть',
    'default-connection-type': 'Способ связи по умолчанию',
};
